import { useState, useEffect, useContext } from "react";
import { Badge, Modal, Table, Button, Spinner } from "react-bootstrap";
import { FileText } from "react-feather";

import authenticatedFetch from  "./fetch"
import getRawDocumentCategories from "./documentCategories";


import NotyfContext from "../contexts/NotyfContext";
import { UserSettingsContext } from "../contexts/UserSettingsContext";

const ExpiringDocumentRow = ({doc, reload}) => {
  const [isMuting, setIsMuting] = useState(false);
  const { isH3Admin, authorities } = useContext(UserSettingsContext);
  let rawDocumentCategories = getRawDocumentCategories(isH3Admin, authorities);
  
  const notyf = useContext(NotyfContext);

  const handleClick = (url) => 
  {
    window.location = url;
  }

  const handleMute = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMuting(true);

    authenticatedFetch({
      method: "POST",
      path: "provider/muteupcomingdocumentexpirationalert",
      requestData: {
        entityType: doc.entityType,
        entityId: doc.entityId,
        filename: doc.filename
      },
      successHandler: function(result) {
        setIsMuting(false);
        reload();
      },
      errorHandler: function(error) {
        setIsMuting(false);
        notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
      }
    });
  }

  var categoryLabel = '';
  if (doc.category)
  {
    for (let i = 0; i < rawDocumentCategories.length; i++)
    {
      if (doc.category === rawDocumentCategories[i].value)
      {
        categoryLabel = rawDocumentCategories[i].label;
        break;
      }
    }
  }

  var parts = doc.expiration.split("-");
  var expiresDate = new Date(parts[0], parts[1] - 1, parts[2]);  // Avoid the UTC->local timezone translation issue with js

  return (
    <tr style={{cursor: "pointer"}} onClick={(e) => handleClick("/" + doc.entityType + "/" + doc.entityId)}>
      <td>{doc.entityFormattedName}</td>
      <td><Badge pill bg="secondary">{categoryLabel}</Badge></td>
      <td style={{whiteSpace:"nowrap"}}>{expiresDate.toLocaleDateString("en-US")}</td>
      <td style={{overflow:"hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "220px"}}>{doc.filename}</td>
      <td style={{minWidth: "50px"}}>
        {isMuting ? <Spinner animation="border" size="sm" variant="primary" style={{marginLeft: "15px"}} />
        :
        <Button variant="secondary" size="sm" onClick={(e) => handleMute(e)}>Mute</Button>
        }
      </td>
    </tr>
    )
}

const ExpiringDocumentsModal = ({show, onClose, documentList, reload}) => {  
  const documentRows = documentList && documentList.length > 0
    && documentList.map((doc, i) => {
      return (
        <ExpiringDocumentRow key={i} doc={doc} reload={reload}/>
        )
  }, this);

  return (
    <Modal show={show} onHide={onClose} scrollable={true} dialogClassName={"modal-850"}>
    <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
      <Modal.Title>
        Document{documentList && documentList.length > 1 ? "s" : ""} Expiring Soon
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Table striped bordered hover size="sm"> 
        <thead>
          <tr>
            <td>Practice / Provider</td>
            <td>Category</td>
            <td>Expiration Date</td>
            <td>Document Name</td>
            <td>&nbsp;</td>
          </tr>
        </thead>
        <tbody>
          {documentRows} 
        </tbody>
      </Table>
    </Modal.Body>
    <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
      <Button onClick={onClose}>Close</Button>
    </Modal.Footer>
  </Modal>
  )
}

const DocumentExpirationCount = ({practiceId}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);

  const { documentsRefresh } = useContext(UserSettingsContext);

  const handleShow = () => 
  {
    if (data.length > 0)
      setShow(true);
  }
  const handleClose = () => setShow(false);

  useEffect(() => {
    reload();
  }, [practiceId, documentsRefresh])

  const reload = () => {
    authenticatedFetch({
      path: "provider/upcomingdocumentexpirationcount" + (practiceId != null && practiceId > 0 ? "/" + practiceId : ""),
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }

  if (!isLoaded)
  {
    return (<>Loading...</>);
  }
  else if (error || data == null)
  {
    return (<>...</>);
  }
  else
  {
    return (
      <>
        <div className="flex-grow-1" style={{cursor: data && data.length > 0 ? 'pointer': 'default'}}  onClick={(e) => handleShow()}>
        <h3 className="mb-2">{!data ? 0 : data.length} Document{!data || data.length === 0 || data.length > 1 ? "s" : ""} Expiring Soon</h3>
        { data && data.length > 0 ?
          <>
            <p className="mb-2">Updates may be needed to avoid contract lapses</p>
            <div className="mb-0">
              <span className="text-muted" style={{fontSize:"0.9em"}}>Expiring </span>
                <Badge bg="" className="badge-soft-danger me-2">
                    soon
                </Badge>
            </div>
          </>
        : <><p className="mb-2">No items expiring soon!</p></>
        }
        </div>
        <div className="d-inline-block ms-3">
          <div className="">
            { data && data.length > 0 ?
              <FileText className="align-middle text-danger" />
            : <FileText className="align-middle" style={{color: '#3AAFA9'}} />
            }
          </div>
        </div>
        <ExpiringDocumentsModal show={show} onClose={handleClose} documentList={data} reload={reload}/>
      </>
    )
  }
}
export default DocumentExpirationCount;